export default "/images/marker-shadow.png";